import { Fragment } from "react";
import { classNames } from "primereact/utils";

import { useFilterPanelContext } from "../filter-panel.context";
import styles from "../filter-panel.module.scss";
import type { FilterPanelRowsProps } from "../types-filter-panel";
import { FilterPanelRow } from "./filter-row";
import { FilterPanelMobileActions } from "./mobile-actions";

export function FilterPanelRows({ className, ...rest }: FilterPanelRowsProps) {
  const panel = useFilterPanelContext();
  const { isMobile } = panel;

  return (
    <div
      className={classNames(styles.group, isMobile && styles.groupMobile, className)}
      {...rest}
      hidden={panel.collapsed}
    >
      {panel.rows.map((row, index) => (
        <Fragment key={row.id}>
          <FilterPanelRow index={index} />
          {isMobile ? <div className={styles.divider} role="separator" /> : null}
        </Fragment>
      ))}
      {isMobile ? <FilterPanelMobileActions /> : null}
    </div>
  );
}
FilterPanelRows.displayName = "FilterPanel.Rows";
